import api from "../../config/client.axios.api";

export const getRevenueEachStoreApi = async (
  startDate: string,
  endDate: string,
  accountId?: string
) => {
  const response = await api.get(`/history/get-revenue-each-store`, {
    params: {
      accountId: accountId && accountId,
      startDate,
      endDate,
    },
  });
  return response.data;
};
